
import emptyData from '~/components/common/emptyData.vue'
export default {
  name: 'ComparePopUp',
  components: {
    'empty-data': emptyData
  },
  props: {
    intro: {
      type: String,
      default: ''
    },
    urlName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showInro: false
    }
  },
  mounted() {
    // console.log(this.intro)
    // this.dealintro()
  },
  methods: {
    dealintro() {
      let txt = this.intro
      if (txt) {
        for (let i = 0; i < 9999; i++) {
          if (txt.includes('<p>　　')) {
            txt = txt ? txt.replace('<p>　　', '<p>') : '--'
          } else {
            break
          }
        }
      }
      return txt
    },
    show() {
      this.showInro = true
    },
    close() {
      this.showInro = false
    }
  }
}
